<template>
    <div class="innerContainer">
        <div class="tela-politica-termos" v-if="data">
            <h1>{{ t('DECLARACAO_PRIVACIDADE') }}</h1>
            <div v-html="data.text"></div>
        </div>
    </div>
</template>
<style lang="scss">
    .tela-politica-termos {
        margin: 60px 0;
        h1 {
            color: #878787;
            margin: 10px 0 40px 0;
        }
        > div {
            color: #222;
        }
        p {
            text-align: left;
        }
    }
</style>

<script>
import { translate } from '../services/translate.service';
    import { resolvePromise, redirect } from '../helpers/helpers'
    import {getActivePrivacyPolicy} from '../services/privacy.service'
    export default {
        name: 'politicaPrivacidade',
        data(){
            return{
                data: null
            }
        },
        components: {
        },
        methods:{
            t:translate,
        },
        created(){
            window.scrollTo(0,0)
            resolvePromise(getActivePrivacyPolicy(),({data}) => this.data = data,console.log,this)
        }
    }
</script>
